<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-07-19 16:53:37
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-21 19:00:49
-->
<template>
  <div class="import-temp">
    <el-upload
      drag
      ref="upload"
      accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.png"
      :headers="uploadHeader"
      :action="uploadFileByContentType"
      :file-list="fileList"
      :on-success="uploadSuc"
      :on-error="uploadErr"
      :on-change="changeData"
      :limit="1"
      :on-remove="removeData"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
    <div class="el-upload__tip" slot="tip">
      <div>
        支持扩展名：支持.doc .docx .xls .xlsx .pdf .jpg .png… 最多上传1份文件
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@utils'
import { uploadFileByContentType } from '@api/yardIntermediary/institutionalManagement'
// import {
//   downLoadImportAppealTemplate,
//   importEntAppeal
// } from '@api/dataMaintenance/dataMaintenance'
export default {
  name: 'ImportTemp',
  data() {
    return {
      data: '1',
      uploadFileByContentType,
      fileList: [],
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      }
    }
  },
  methods: {
    // 上传成功
    uploadSuc(response) {
      this.$emit('uploadOver', { type: 1, data: response })
    },
    // 上传失败
    uploadErr(errmsg) {
      this.$emit('uploadOver', { type: 0, data: errmsg })
    },
    changeData(file, fileList) {
      this.fileList = fileList
    },
    removeData(file, fileList) {
      this.fileList = fileList
    },
    submit() {
      if (this.fileList.length == 0) {
        this.$message({
          message: '请选择文件后进行提交操作',
          type: 'warning'
        })
        return
      }
      this.$refs.upload.submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.import-temp {
  /deep/.el-upload {
    display: block;
  }
  /deep/.el-upload-dragger {
    width: 100%;
  }
  .el-upload__tip {
    div {
      margin: 5px 0;
      line-height: 20px;
      font-size: 14px;
    }
    div:nth-child(2n + 1) {
      color: black;
    }
    div:nth-child(3) {
      margin-bottom: 0;
    }
  }
}
</style>
